import {
  CumulativeStat,
  DifferentialStat,
  ProjectSheetsStat,
  ProjectSpheresStat,
  ProjectSqftStat,
  ProjectStat,
  StatPair,
  StatPairBase,
} from "@custom-types/analytics-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Type guard that validates a stat to be of type ProjectStat */
export function isProjectStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is ProjectStat {
  return stat.name === "project-count" || stat.name === "project-count-abs";
}

/** Type guard that validates a stat to be of type ProjectSqftStat */
export function isProjectSqftStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is ProjectSqftStat {
  return stat.name === "project-sqft" || stat.name === "project-sqft-abs";
}

/** Type guard that validates a stat to be of type ProjectSpheresStat */
export function isProjectSpheresStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is ProjectSpheresStat {
  return stat.name === "project-spheres" || stat.name === "project-spheres-abs";
}

/** Type guard that validates a stat to be of type ProjectSheetsStat */
export function isProjectSheetsStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is ProjectSheetsStat {
  return stat.name === "project-sheets" || stat.name === "project-sheets-abs";
}

/** Type guard that validates a stat to be of type CumulativeStat */
export function isCumulativeStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is CumulativeStat {
  return stat["data-generation"] === "cumulative";
}

/** Type guard that validates a stat to be of type DifferentialStat */
export function isDifferentialStat(
  stat: FaroCoreApiTypes.CompanyStatistic
): stat is DifferentialStat {
  return stat["data-generation"] === "differential";
}

/** Type guard that validates a stat pair to be of type StatPair */
export function isStatPair(statPair: StatPairBase): statPair is StatPair {
  return "cumulative" in statPair && "differential" in statPair;
}
